import { createApp } from 'vue'
import App from './App.vue'
import Vuex from 'vuex';
import Axios from 'axios';
import './registerServiceWorker'
import router from './router'
import store from './store'
import FooterMenu from "@/components/FooterMenu";
import BackButton from "@/components/BackButton.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from 'moment';
import registerPushWorker from './registerServiceWorker';

// Push-Worker verzögert initialisieren nach Store-Setup, aber nur wenn bereits erlaubt
setTimeout(() => {
  if (store.state.token && ('Notification' in window) && Notification.permission === 'granted') {
    registerPushWorker();
  }
}, 1000);

// set auth header
Axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

// Add response interceptor for automatic logout on token expiry
Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if error is due to invalid/expired token
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Check if the error message indicates token issues
      const errorMsg = error.response.data?.msg || '';
      if (errorMsg.includes('Sitzung') || errorMsg.includes('valide') || errorMsg.includes('abgelaufen') || error.response.status === 401) {
        // Clear the token and user data
        store.dispatch('logout');
        
        // Clear axios default header
        delete Axios.defaults.headers.common['Authorization'];
        
        // Redirect to login page if not already there
        if (router.currentRoute.value.path !== '/login') {
          router.push('/login');
        }
      }
    }
    
    return Promise.reject(error);
  }
);

createApp(App).use(store).use(router).use(Vuex).use(moment).component('FooterMenu', FooterMenu).component('BackButton', BackButton).component('LoadingSpinner', LoadingSpinner).mount('#app')
